import * as React from "react";
import { Typeahead } from 'react-bootstrap-typeahead';

// TypeaheadEnterEscWrapper stops Enter and Esc propagation when menu is open
export class TypeaheadEnterEscWrapper extends React.Component<any>
{
    private typeahead: Typeahead;    
    render()
    {
        const children = this.props.children;
        if (Array.isArray(children)) {
            throw new Error('children of TypeaheadEnterEscWrapper has to be a Typeahead component');
        }

        return (
            <div onKeyDown={e => {
                const comp = this.typeahead.getInstance();
                (e.keyCode === 13) && comp.state.showMenu && e.stopPropagation(); // stop Enter/Return keyDown event propagation
                (e.keyCode === 27) && comp.state.showMenu && e.stopPropagation(); // stop Esc keyDown event propagation
            }}>
                { React.cloneElement(children as Typeahead, { ref: (e) => this.typeahead = e })}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/TypeaheadEnterEscWrapper.tsx